import * as React from "react";
import { Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getRandomColorBasedOnString } from "src/utils/colors";

interface Props {
  text: string;
  randomColor?: boolean;
}
const WHITESPACE = " ";

const getAvatarLetters = (words: string): string => {
  if (!words) return "";
  const wordArray = words.split(WHITESPACE);

  if (!wordArray.length) return "??";
  const secondLetter = wordArray[1]
    ? wordArray[1].charAt(0).toUpperCase()
    : wordArray[0].length > 1
    ? wordArray[0].charAt(1)
    : "";

  return `${wordArray[0].charAt(0).toUpperCase()}${
    wordArray.length > 1
      ? wordArray[1].charAt(0).toUpperCase()
      : secondLetter.toUpperCase()
  }`;
};

const dynamicStyles = (text: string): (() => { avatar: string }) =>
  makeStyles((theme) => {
    // const backgroundColor = getRandomMaterialColor();
    const backgroundColor = getRandomColorBasedOnString(text);

    return {
      avatar: {
        color: theme.palette.getContrastText(backgroundColor),
        backgroundColor,
      },
    };
  });

const staticStyles = makeStyles((theme) => {
  return {
    avatar: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.getContrastText(theme.palette.grey[200]),
    },
  };
});

const LetterAvatar = ({ text, randomColor = false }: Props): JSX.Element => {
  const classes = randomColor ? dynamicStyles(text)() : staticStyles();
  const letters = getAvatarLetters(text);

  return <Avatar className={classes.avatar}>{letters}</Avatar>;
};

export default React.memo(LetterAvatar);
